import styled from "styled-components";
import Button from "@material-ui/core/Button";
import { CandyMachineAccount } from "./candy-machine";
import { CircularProgress } from "@material-ui/core";
import { GatewayStatus, useGateway } from "@civic/solana-gateway-react";
import { useEffect, useState } from "react";

export const CTAButton = styled(Button)`
	background: linear-gradient(
		0deg,
		rgb(3, 79, 122) 0%,
		rgb(31, 139, 172) 20%,
		rgb(85, 241, 228) 80%
	);
	);
	padding: 0.25em 0.5em;
	height: auto;
	width: 100%;
	border-radius: 0.5rem;
	border: none !important;
	border-style: none !important;
	font-style: bold !important;
	font-size: 1.3rem !important;
	font-family: "RussoOne" !important;
	transition: all 300ms linear !important;
	text-transform: uppercase;
	letter-spacing: 0.1rem;
	margin-bottom: 1rem !important;
	box-shadow: 0 0.15em 0 0 black !important;
	text-align: center;
	color: white;
`; // add your own styles here

export const MintButton = ({
	onMint,
	candyMachine,
	isMinting,
}: {
	onMint: () => Promise<void>;
	candyMachine?: CandyMachineAccount;
	isMinting: boolean;
}) => {
	const { requestGatewayToken, gatewayStatus } = useGateway();
	const [clicked, setClicked] = useState(false);

	useEffect(() => {
		if (gatewayStatus === GatewayStatus.ACTIVE && clicked) {
			onMint();
			setClicked(false);
		}
	}, [gatewayStatus, clicked, setClicked, onMint]);

	const getMintButtonContent = () => {
		if (candyMachine?.state.isSoldOut) {
			return "SOLD OUT";
		} else if (isMinting) {
			return <CircularProgress />;
		} else if (candyMachine?.state.isPresale) {
			return "PRESALE MINT";
		}

		return "MINT";
	};

	return (
		<CTAButton
			disabled={
				candyMachine?.state.isSoldOut ||
				isMinting ||
				!candyMachine?.state.isActive
			}
			onClick={async () => {
				setClicked(true);
				if (candyMachine?.state.isActive && candyMachine?.state.gatekeeper) {
					if (gatewayStatus === GatewayStatus.ACTIVE) {
						setClicked(true);
					} else {
						await requestGatewayToken();
					}
				} else {
					await onMint();
					setClicked(false);
				}
			}}
			variant='contained'
		>
			{getMintButtonContent()}
		</CTAButton>
	);
};
